import type { DriverTeamEntity } from '@/features/driverTeam/domain/entities/DriverTeamEntity'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { SystemSalaryMiniEntity } from '@/features/systemSalary/domain/entities/SystemSalaryMiniEntity'
import type { VehicleTemplateEntity } from '@/features/vehicleTemplate/domain/entities/VehicleTemplateEntity'
import type { DriverOrderSupportType } from '../enums/DriverOrderSupportType'
import type { DayOfWeek } from '@/shared/enums/DayOfWeekEnum'

export class CreateUpdateDriverEntity {
  workingPhoneNumber?: string
  fullName?: string
  region?: RegionMiniEntity
  avatarImagePath?: string
  imageData?: { bytes: string; fileName: string }
  salarySystem?: SystemSalaryMiniEntity
  vehicleTemplate?: VehicleTemplateEntity
  password?: string
  driverTeams?: DriverTeamEntity[] | null
  user?: {
    id?: string
  }
  orderSupportTypes?: DriverOrderSupportType[]
  defaultDayOff?: DayOfWeek | null
}
